module.exports = __webpack_public_path__ + "static/img/lixinkuaiji.b8de386.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/lixinkuaiji.jpg
// module id = aoee
// module chunks = 46